import React, { useEffect, useLayoutEffect, useState } from "react";
import "./index.scss";

import { BsBan, BsEye } from "react-icons/bs";
import { FaEdit } from "react-icons/fa";
import { FiCheckSquare } from "react-icons/fi";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import AppButton from "../../../components/appButton";
import DataTableDisplay from "../../../components/tableMission";
import { showErrorToaster } from "../../../components/toaster/error";
import MissionService from "../../../services/mission/mission.service";
import MissionResponsiveCards from "../missionCardResponsive";

const missionService = new MissionService();

function MissionListe() {
  const [mission, setMission] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth);
  const [action, setAction] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedMission, setSelectedMission] = useState(null);

  const loadData = async () => {
    setIsLoading(true);

    try {
      const res = await missionService?.getAllMission();
      // Sort missions from newest to oldest
      const sortedMissions = (res?.data || []).sort((a, b) => {
        // Sort by createdAt if available, otherwise by _id (MongoDB ObjectId contains timestamp)
        let dateA = 0;
        let dateB = 0;
        
        if (a.createdAt) {
          dateA = new Date(a.createdAt).getTime();
        } else if (a._id) {
          // Extract timestamp from MongoDB ObjectId (first 8 characters are timestamp in hex)
          dateA = parseInt(a._id.substring(0, 8), 16) * 1000;
        }
        
        if (b.createdAt) {
          dateB = new Date(b.createdAt).getTime();
        } else if (b._id) {
          // Extract timestamp from MongoDB ObjectId (first 8 characters are timestamp in hex)
          dateB = parseInt(b._id.substring(0, 8), 16) * 1000;
        }
        
        return dateB - dateA; // Newest first
      });
      setMission(sortedMissions);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleStatus = async (id, status) => {
    setIsLoading(true);
    const data = { status: !status };
    try {
      await missionService?.toggleMStatus(id, data);
      await loadData(); // Reload data after status change
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }

    setIsLoading(false);
  };

  const columnsAbonnement = [
    {
      name: "Titre",
      selector: (row) => (
        <div className="table-text capitalize">
          {row?.title != null && row?.title}
        </div>
      ),
      hide: "md",
      sortable: true,
    },
    {
      name: "Durée",
      selector: (row) => (
        <div className="table-text">
          {row?.duration != null && row?.duration}
        </div>
      ),
      hide: "md",
      sortable: true,
    },
    {
      name: "Type Contrat",
      selector: (row) => (
        <div className="table-text">
          {row?.typeContrat != null && row?.typeContrat}
        </div>
      ),
      hide: "md",
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => (
        <div
          style={{
            padding: "1rem",
          }}>
          <span
            style={{
              padding: "5px 10px",
              borderRadius: "12px",
              color: row?.status === true ? "#00AC0E" : "#EE0202",
              backgroundColor: row?.status === true ? "#D2FFD6" : "#FFD8D8",
            }}>
            {row?.status === true ? "Active" : "Inactive"}
          </span>
        </div>
      ),
      center: true,
      sortable: true,
    },
    {
      name: "Actions",
      center: true,
      cell: (row) => (
        <div className="d-flex w-100 justify-content-center align-items-center">
          <button
            data-bs-toggle="modal"
            data-bs-target="#createUserModal"
            type="button"
            className="btn btn-link"
            onClick={() => {
              navigate(`/edit-mission/${row?._id}`);
              window.scrollTo(0, 0);
            }}>
            <label className="mx-1">
              <FaEdit />
            </label>
          </button>
          <button
            className="btn btn-link"
            onClick={async () => {
              await handleStatus(row?._id, row?.status);
            }}
            type="button">
            {row?.status === true ? (
              <label className="mx-1">
                <BsBan style={{ color: "#EE0202" }} />
              </label>
            ) : (
              <label className="mx-1">
                <FiCheckSquare style={{ color: "#00AC0E" }} />
              </label>
            )}
          </button>
          <button
            className="btn btn-link"
            onClick={() => {
              setSelectedMission(row);
              setShowDetailsModal(true);
            }}
            type="button"
            title="Voir les détails">
            <label className="mx-1">
              <BsEye style={{ color: "#007bff" }} />
            </label>
          </button>
        </div>
      ),
    },
  ];
  useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 3; // Adjust this number as needed

  // Calculate the offset
  const offset = currentPage * itemsPerPage;

  // Slice the missions list based on the current page and items per page
  const currentMissions = mission.slice(offset, offset + itemsPerPage);

  // Handle page change
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  return (
    <section className="usersPage">
      <div className="container-fluid">
        <div className="row my-0 my-md-5  align-items-center">
          <div className="col-auto">
            <h3 className="mb-0">Offres liste</h3>
          </div>
          <div className="col-auto ms-auto">
            <AppButton
              text="Ajouter offre"
              color="bleu"
              size="medium"
              className="add-btn"
              onClick={() => {
                navigate("/add-mission");
                window.scrollTo(0, 0);
              }}
            />
          </div>
        </div>

        {isLoading ? (
          <div className="d-flex my-0 my-md-5  justify-content-center align-items-center"></div>
        ) : (
          <div className=" my-0 my-md-5 py-2">
            {isMobile > 599 ? (
              <DataTableDisplay columns={columnsAbonnement} data={mission} />
            ) : (
              <>
                {mission.map((item) => (
                  <MissionResponsiveCards
                    key={item.id} // Ensure the key is unique for each item
                    handleStatus={handleStatus}
                    mission={item}
                    setAction={setAction}
                    setSelectedId={setSelectedId}
                    loadData={loadData}
                  />
                ))}
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={Math.ceil(mission.length / itemsPerPage)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </>
            )}
          </div>
        )}
      </div>

      {/* Mission Details Modal */}
      <Modal
        show={showDetailsModal}
        onHide={() => setShowDetailsModal(false)}
        centered
        size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Détails de la Mission</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedMission && (
            <div className="mission-details">
              <div className="mb-3">
                <strong>Titre:</strong>
                <p className="mb-0">{selectedMission?.title || "N/A"}</p>
              </div>
              <div className="mb-3">
                <strong>Description:</strong>
                <div
                  className="mb-0"
                  dangerouslySetInnerHTML={{
                    __html: selectedMission?.description || "N/A",
                  }}
                />
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <strong>Pays:</strong>
                  <p className="mb-0">{selectedMission?.paye || "N/A"}</p>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Durée:</strong>
                  <p className="mb-0">{selectedMission?.duration || "N/A"}</p>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Type de Contrat:</strong>
                  <p className="mb-0">{selectedMission?.typeContrat || "N/A"}</p>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Niveau:</strong>
                  <p className="mb-0">{selectedMission?.level || "N/A"}</p>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Type de travail:</strong>
                  <p className="mb-0">{selectedMission?.typeWork || "N/A"}</p>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>Status:</strong>
                  <p className="mb-0">
                    <span
                      style={{
                        padding: "5px 10px",
                        borderRadius: "12px",
                        color:
                          selectedMission?.status === true
                            ? "#00AC0E"
                            : "#EE0202",
                        backgroundColor:
                          selectedMission?.status === true
                            ? "#D2FFD6"
                            : "#FFD8D8",
                      }}>
                      {selectedMission?.status === true ? "Active" : "Inactive"}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => setShowDetailsModal(false)}>
            Fermer
          </button>
        </Modal.Footer>
      </Modal>
    </section>
  );
}

export default MissionListe;
